module.exports = __webpack_public_path__ + "img/H3.dcbb8f19.png";